<script>
	import Widget from './Widget.svelte';

	const menu = [
		{label: 'Kleuren', scroll: 'color', icon: 'palette', active: true},
	];
</script>

<Widget menu="{menu}" title="Weergave"/>